document.addEventListener("DOMContentLoaded", () => {
  const miniCartContainer = document.querySelector(".cart_content");
  if (miniCartContainer) {
    const textInput = document.getElementById("note");
    const limitMessage = document.querySelector(".limitMessage");
    const miniCartForm = document.getElementById("mini-cart-form");
    const checkBox = document.querySelector(".note-toggle"); // Checkbox for gift option
    const confirmBtn = document.querySelector(".add_to_cart");
    const continueBtn = document.querySelector(".cart_content__continue-shopping");
    const giftDiv = document.querySelector(".mini-cart-gift-message");
    


// HIDE the checkbox, text input, and limit message
    checkBox.style.display = "none";
    textInput.style.display = "none";
    limitMessage.style.display = "none";

    // Remove event listeners tied to the checkbox and text input to prevent interactions
    // This section of code controls the checkbox behavior
    /*
    checkBox.addEventListener("click", (e) => {
      checked = !checked;
      finalStep = false;
      if (checked) {
        confirmBtn.textContent = "check out";
        textInput.style.display = "block";
        limitMessage.style.display = "block";
        continueBtn.style.display = "none";
      } else {
        textInput.value = "";
        setWordsLimitMessage();
        confirmBtn.textContent = "check out";
        continueBtn.style.display = "flex";
        textInput.style.display = "none";
        preview.style.display = "none";
        editBtn.style.display = "none";
        limitMessage.style.display = "none";
      }
    });
    */

    // Insert your new Giftnote button here
   giftDiv.insertAdjacentHTML('beforeend', `
      <template id="gift_message_button">
        <style>
          giftnote-button {
            font-family: 'Inconsolata', monospace !important; /* Set font to Inconsolata */
          }
    
          button#button {
            font-family: 'Inconsolata', monospace !important; /* Force Inconsolata for the button */
          }
    
          button#button span {
            font-family: inherit; /* Ensure child spans inherit the button font */
          }
        </style>
      </template>
      <giftnote-button
        data-styles="gift_message_button"
        data-add="Add a gift message 🎁"
        data-edit="Edit gift message 🎁"
      ></giftnote-button>
    `);


    
    const preview = document.createElement("div");
    preview.className = "preview-message";
    let editBtn = document.createElement("button");
    editBtn.className = "edit-btn";
    editBtn.textContent = "edit gift message";
    let finalStep = false;
    let checked;
    if (checkBox.classList.contains("checked")) {
      checked = true
      confirmBtn.textContent = "check out";
      continueBtn.style.display = "none";
    } else {
      confirmBtn.textContent = "check out";
      continueBtn.style.display = "flex";
      limitMessage.style.display = 'none'
      checked = false
    }

    checkBox.addEventListener("click", (e) => {
      checked = !checked;
      finalStep = false;
      if (checked) {
        confirmBtn.textContent = "check out";
        textInput.style.display = "block";
        limitMessage.style.display = "block";
        continueBtn.style.display = "none";
      } else {
        textInput.value = "";
        setWordsLimitMessage();
        confirmBtn.textContent = "check out";
        continueBtn.style.display = "flex";
        textInput.style.display = "none";
        preview.style.display = "none";
        editBtn.style.display = "none";
        limitMessage.style.display = 'none'
      }
    });

    const submitHandler = (e) => {
      e.preventDefault();
      if (!finalStep) {
        giftDiv.insertBefore(editBtn, confirmBtn.nextSibling);
        preview.textContent = textInput.value;
        giftDiv.insertBefore(preview, confirmBtn);
        limitMessage.style.display = "none";
        textInput.style.display = "none";
        editBtn.style.display = "block";
        preview.style.display = "block";
        confirmBtn.textContent = "looks good - check out";
        finalStep = true;
      }
    };
    const editHandler = (e) => {
      e.preventDefault();
      limitMessage.style.display = "block";
      textInput.style.display = "block";
      preview.style.display = "none";
      editBtn.style.display = "none";
      confirmBtn.textContent = "check out";
      finalStep = false;
    };
    const confirmHandler = (e) => {
      if (finalStep || !checked || textInput.value.length === 0) {
        miniCartForm.removeEventListener("submit", submitHandler);
        editBtn.removeEventListener("click", editHandler);
        finalStep = false;
      } else {
        miniCartForm.addEventListener("submit", submitHandler);
        editBtn.removeEventListener("click", editHandler);
      }
      if (editBtn) {
        editBtn.addEventListener("click", editHandler);
      }
    };

    confirmBtn.addEventListener("click", confirmHandler);
    miniCartForm.addEventListener("submit", submitHandler);
  }
});
